import React from "react";
import { AppBar, Box, Typography } from "@mui/material";

import NavbarHotelDropdown from "./navbar-hotel-dropdown";
import UserMenu from "./user-manu";
//
const Navbar = () => {
  //
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        height: 75,
        maxHeight: 75,
        padding: 0,
        margin: 0,
        backgroundColor: "#2e384a",
      }}
    >
      <Box
        display={"flex"}
        alignItems="center"
        flexDirection={"row"}
        maxHeight={75}
      >
        {/* <Grid item xs={2}>
          <HotelSelect
            hotel={hotel}
            setHotel={(e, value) => dispatch(globalActions.setHotel(value))}
          />
        </Grid>  */}

        <Typography
          sx={{
            color: "#e5e5e5",
            display: {
              xs: "none",
              sm: "none",
              cc: "none",
              md: "none",
              lg: "block",
            },
            fontSize: 18,
            pl: 8,
            pt: 4,
          }}
          maxHeight={75}
        >
          Revenue Optimization Platform
        </Typography>

        <Box
          width={"80%"}
          display={"flex"}
          alignItems={"end"}
          justifyContent={"center"}
          pr={16}
        >
          <NavbarHotelDropdown />
        </Box>
        <UserMenu />
        {/*<Grid item xs={2}>
          <CurrencySelect
            currency={currency}
            setCurrency={(e, value) => dispatch(globalActions.setCurrency(value))}
          />
        </Grid>*/}
      </Box>
    </AppBar>
  );
};
//
export default Navbar;
